import { createLifecycleLogger } from './loggerCore';
import {
  capturePaymentCompleted,
  capturePaymentFailed,
  capturePaymentSubmitted,
} from './paymentAnalytics';
import type { ObservabilityContext } from './observability';

const baseLifecycle = createLifecycleLogger('payment', 'Payment');

/** Portal + PAC payment lifecycle: structured logs + PostHog funnel events. */
export const paymentLifecycleLog = {
  started: (context?: ObservabilityContext) => {
    baseLifecycle.started(context);
    capturePaymentSubmitted(context);
  },
  completed: (context?: ObservabilityContext) => {
    baseLifecycle.completed(context);
    capturePaymentCompleted(context);
  },
  failed: (error: Error | string, context?: ObservabilityContext) => {
    baseLifecycle.failed(error, context);
    capturePaymentFailed(error, context);
  },
  skipped: baseLifecycle.skipped,
  retried: baseLifecycle.retried,
};

export const paymentLogger = paymentLifecycleLog;
